export default function SchemesSection() {
  const schemes = [
    {
      id: 'ttps',
      icon: 'ri-rocket-line',
      iconBg: 'from-red-500 to-orange-500',
      emoji: '🚀',
      title: '高端人才通行證計劃',
      subtitle: 'TTPS · 高才通',
      suitable: '高收入人士、世界百強名校畢業生',
      advantages: '無需先獲僱主聘用，獲批速度快',
      requirements: [
        'A類：申請前一年年薪達港幣 250 萬元或以上',
        'B/C類：畢業於全球百強大學（包括部分內地頂尖高校），並符合相關工作經驗要求'
      ],
      expert: '這是目前最熱門的「快車道」，特別適合希望快速取得香港身份的精英群體。',
      color: 'red'
    },
    {
      id: 'asmtp',
      icon: 'ri-briefcase-line',
      iconBg: 'from-blue-500 to-indigo-500',
      emoji: '💼',
      title: '輸入內地人才計劃',
      subtitle: 'ASMTP · 專才',
      suitable: '已獲得香港公司聘用的內地專業人士',
      advantages: '無配額限制，獲批率高，覆蓋行業廣泛',
      requirements: [
        '必須先獲得香港僱主聘用',
        '薪酬福利須達到市場水平'
      ],
      expert: '傳統且穩健的途徑。如果您已經在香港找到了工作，這就是您的最佳選擇。',
      color: 'blue'
    },
    {
      id: 'qmas',
      icon: 'ri-star-line',
      iconBg: 'from-purple-500 to-pink-500',
      emoji: '🌟',
      title: '優秀人才入境計劃',
      subtitle: 'QMAS · 優才',
      suitable: '高學歷、具備國際視野或豐富管理經驗的綜合型人才',
      advantages: '無需先獲僱主聘用，續簽靈活，計分制評核',
      requirements: [
        '透過「綜合計分制」評估年齡、學歷、工作經驗、語文能力等',
        '或透過「成就計分制」證明擁有傑出成就（如國際獎項）'
      ],
      expert: '適合具有潛力但在港尚未有明確工作的人士，2025年起機制更聚焦於頂尖人才的選拔。',
      color: 'purple'
    },
    {
      id: 'cies',
      icon: 'ri-money-dollar-circle-line',
      iconBg: 'from-amber-500 to-yellow-500',
      emoji: '💰',
      title: '新資本投資者入境計劃',
      subtitle: 'New CIES · 投資移民',
      suitable: '高淨值資產人士（需具備外國永久居民身份）',
      advantages: '用資金換取身份，無需在港工作或創業',
      requirements: [
        '在港投資最少 3,000 萬港元於獲許投資資產',
        '包括股票、基金、非住宅房地產等'
      ],
      expert: '為財富自由人士設計的專屬通道，更是家族資產配置的優選方案。',
      color: 'amber'
    }
  ];

  return (
    <section id="schemes" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            四大核心移居計劃精選
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            根據您的背景和需求，選擇最適合的入境途徑
          </p>
        </div>

        <div className="space-y-8">
          {schemes.map((scheme, index) => (
            <div 
              key={scheme.id}
              className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 md:p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200"
            >
              <div className="flex flex-col lg:flex-row gap-8">
                <div className="flex-shrink-0">
                  <div className={`w-20 h-20 bg-gradient-to-br ${scheme.iconBg} rounded-2xl flex items-center justify-center shadow-lg`}>
                    <i className={`${scheme.icon} text-4xl text-white`}></i>
                  </div>
                </div>

                <div className="flex-1">
                  <div className="flex items-start gap-3 mb-4">
                    <span className="text-4xl">{scheme.emoji}</span>
                    <div>
                      <h3 className="text-3xl font-bold text-gray-900 mb-2">
                        {scheme.title}
                      </h3>
                      <p className="text-lg text-gray-500 font-medium">{scheme.subtitle}</p>
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6 mb-6">
                    <div className="bg-white rounded-xl p-5 border border-gray-200">
                      <div className="flex items-center gap-2 mb-3">
                        <i className="ri-user-star-line text-xl text-teal-600"></i>
                        <h4 className="font-bold text-gray-900">適合對象</h4>
                      </div>
                      <p className="text-gray-700">{scheme.suitable}</p>
                    </div>

                    <div className="bg-white rounded-xl p-5 border border-gray-200">
                      <div className="flex items-center gap-2 mb-3">
                        <i className="ri-checkbox-circle-line text-xl text-teal-600"></i>
                        <h4 className="font-bold text-gray-900">核心優勢</h4>
                      </div>
                      <p className="text-gray-700">{scheme.advantages}</p>
                    </div>
                  </div>

                  <div className="bg-blue-50 rounded-xl p-5 mb-6 border border-blue-100">
                    <div className="flex items-center gap-2 mb-3">
                      <i className="ri-file-list-3-line text-xl text-blue-600"></i>
                      <h4 className="font-bold text-gray-900">申請門檻</h4>
                    </div>
                    <ul className="space-y-2">
                      {scheme.requirements.map((req, idx) => (
                        <li key={idx} className="flex items-start gap-2 text-gray-700">
                          <i className="ri-arrow-right-s-line text-blue-600 mt-1 flex-shrink-0"></i>
                          <span>{req}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-gradient-to-r from-teal-50 to-green-50 rounded-xl p-5 border border-teal-100">
                    <div className="flex items-start gap-3">
                      <i className="ri-lightbulb-line text-2xl text-teal-600 flex-shrink-0 mt-1"></i>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-2">專家點評</h4>
                        <p className="text-gray-700 leading-relaxed">{scheme.expert}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
